/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentPreviewCandidateResolvedEmailType = typeof EnrollmentPreviewCandidateResolvedEmailType[keyof typeof EnrollmentPreviewCandidateResolvedEmailType] | null;


export const EnrollmentPreviewCandidateResolvedEmailType = {
  personal: 'personal',
  professional: 'professional',
} as const;
